import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import DSC_3862r from "../downloads/Selects for Website/DSC_3862_ppr.JPG";
import DSC_8968r from "../downloads/Selects for Website/DSC_8968r.JPG";
import DSC_8534r from "../downloads/Selects for Website/DSC_8534r.JPG";
import "./Services.css";

const Home = () => {
  return (
    <header className="App-header">
      {/* <div
        className="homeText"
        style={{ marginBottom: "20px", marginTop: "80px" }}
      >
        <h1>Commercial Photography</h1>
        <p>
          Whether you need striking location shots or professional business
          portraits, our team is here to help showcase you and your business.
        </p>
        <p>
          Contact us to elevate your brand with high-quality commercial
          photography.
        </p>
      </div> */}
      <div className="servicesContainer">
        <div className="servicesBackgroundImage">
          <div
            id="carouselExample"
            className="services__carousel carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-inner wh-100p">
              <div className="carousel-item active">
                <img
                  src={DSC_3862r}
                  className="services__image"
                  alt="portrait1"
                />
              </div>
              <div className="carousel-item">
                <img
                  src={DSC_8968r}
                  className="services__image"
                  alt="portrait2"
                />
              </div>
              <div className="carousel-item">
                <img
                  src={DSC_8534r}
                  className="services__image"
                  alt="portrait3"
                />
              </div>
            </div>

            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExample"
              data-bs-slide="prev"
            >
              <span className="carousel-control-prev-icon" aria-hidden="true" />
              <span className="visually-hidden">Previous</span>
            </button>

            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#carouselExample"
              data-bs-slide="next"
            >
              <span className="carousel-control-next-icon" aria-hidden="true" />
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div className="servicesText">
          <h1>Commercial Photography</h1>
          <p className="bodyFont">
            Whether you need striking location shots or professional business
            portraits, our team is here to help showcase you and your business.
            <br /> Contact us to elevate your brand with high-quality commercial
            photography.
          </p>
        </div>
      </div>
    </header>
  );
};

export default Home;
